export function filterItems(originalItems, originalItemKeyProperty, needItems) {
  return originalItems.reduce((res, item) => {
    if (needItems.includes(item[originalItemKeyProperty])) {
      res.push(item);
    }

    return res;
  }, []);
}

export function filterItemsWithOrder(originalItems, originalItemKeyProperty, needItems) {
  return needItems.reduce((res, needItem) => {
    const item = originalItems.find(item => item[originalItemKeyProperty] === needItem);
    if (item) {
      res.push(item);
    }

    return res;
  }, []);
}
